import React, { FC } from 'react';

type TableHeaderProps = {
  rows: any[];
  columns: any[];
  selectedIds: Number[];
  setSelectedIds: Function;
  tableColumnExtensions: any;
};

const TableHeader: FC<TableHeaderProps> = ({
  rows,
  columns,
  selectedIds,
  setSelectedIds,
  tableColumnExtensions
}) => {
  return (
    <React.Fragment>
      <thead
        style={{
          position: 'sticky',
          insetBlockStart: 0,
          zIndex: 1
        }}
        className='sticky bg-gray-200 !rounded-none'
      >
        <tr
          style={{
            backgroundColor: 'transparent',
            inlineSize: '100%'
          }}
        >
          {selectedIds?.length > 0 ? (
            <td
              className='SelectionCell'
              style={{
                backgroundColor: 'transparent',
                fontFamily: 'inherit',
                fontSize: '12px',
                padding: '18px 0px',
                inlineSize: '50px'
              }}
            >
              <div className='flex flex-row  justify-content-between  align-items-center rounded'>
                <div className='flex flex-row justify-content-between align-items-center rounded  px-2'>
                  <div
                    onClick={event => {
                      event.stopPropagation();
                      setSelectedIds([]);
                    }}
                    className='cursor-pointer'
                    style={{
                      inlineSize: 15,
                      blockSize: 15,
                      borderStyle: 'solid',
                      borderRadius: 4,
                      borderWidth: '1px',
                      borderColor: 'black',
                      textAlign: 'center'
                      // backgroundColor: 'gray',
                    }}
                  >
                    <div
                      style={{ position: 'relative', insetBlockStart: -3 }}
                      className='text-black'
                    >
                      -
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 13,
                      marginLeft: 10
                    }}
                    className='w-max absolute left-[25px] top-[15px] rounded'
                  >
                    {selectedIds?.length} Selected
                  </div>
                </div>
              </div>
            </td>
          ) : (
            <td
              className='Cell w-[40px]'
              style={{
                color: 'grey',
                backgroundColor: 'transparent',
                fontFamily: 'inherit',
                fontSize: '12px',
                padding: '20px 10px'
              }}
            >
              <input
                type='checkbox'
                className='cursor-pointer'
                checked={Boolean(selectedIds?.length > 0 ? true : false)}
                onChange={() => {
                  if (selectedIds?.length === 0) {
                    setSelectedIds(() => rows?.map(row => row?.id));
                  } else {
                    setSelectedIds([]);
                  }
                }}
              />
            </td>
          )}

          {columns?.map((col, colIndex) => {
            // GET COLUMN EXTENSION
            const columnExtension = tableColumnExtensions?.find(
              (item: { columnName: any }) => item?.columnName === col?.name
            );
            const width = columnExtension?.width || 100;
            return (
              <td
                style={{
                  color: 'grey',
                  backgroundColor: 'transparent',
                  fontFamily: 'inherit',
                  fontSize: '13px',
                  fontWeight: '500',
                  padding: '20px 10px',
                  minWidth: width,
                  inlineSize: width || '100px'
                }}
                key={colIndex}
                color={'grey'}
                className='Cell'
                // width={width || 100}
              >
                <div className='-mt-1'>{selectedIds?.length === 0 ? col?.title : ''}</div>
              </td>
            );
          })}
        </tr>
      </thead>
    </React.Fragment>
  );
};

export default TableHeader;
